import { FacetListDTO, ListItem, MappedFacetListItem } from "./filters.type";
import { FILTER_KEYS_BY_ORDER } from "./constants";

export const mapFacetList = (result: FacetListDTO): MappedFacetListItem[] => {
  const facetNames = Object.keys(result).filter(
    (item) => item !== "degradedServices"
  );

  const getDisplayLabel = (label: string) => {
    if (label === "V5 Present") {
      return "V5";
    }
    if (label === "Report Available") {
      return "Battery Grade";
    }
    return label;
  };

  const topLevelFilters = facetNames
    .map((facet: string) => {
      const facetType = result[facet] as ListItem[];
      return facetType.map(
        (details: ListItem): MappedFacetListItem => ({
          displayLabel: getDisplayLabel(details.label),
          filterType: details.type,
          key: details.key,
          parentFilterKey: details.parentFacetKey,
        })
      );
    })
    .flat();

  // Create new ordered array based upon the FILTER_KEYS_BY_ORDER...
  const orderedFilters: MappedFacetListItem[] = [];
  FILTER_KEYS_BY_ORDER.forEach((key: string) => {
    const foundItem = topLevelFilters.find(
      (item: MappedFacetListItem) => item.key === key
    );
    if (foundItem) {
      orderedFilters.push(foundItem);
    }
  });

  return orderedFilters;
};
